import { render, staticRenderFns } from "./imagem-nao-disponivel.vue?vue&type=template&id=53584e42&scoped=true&"
import script from "./imagem-nao-disponivel.vue?vue&type=script&lang=js&"
export * from "./imagem-nao-disponivel.vue?vue&type=script&lang=js&"
import style0 from "./imagem-nao-disponivel.vue?vue&type=style&index=0&id=53584e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53584e42",
  null
  
)

export default component.exports